import { render, staticRenderFns } from "./SettingsApplication.vue?vue&type=template&id=0a0b2a5a&scoped=true&"
import script from "./SettingsApplication.vue?vue&type=script&lang=js&"
export * from "./SettingsApplication.vue?vue&type=script&lang=js&"
import style0 from "./SettingsApplication.vue?vue&type=style&index=0&id=0a0b2a5a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a0b2a5a",
  null
  
)

export default component.exports